import { forjaBatchStore } from '@mxa-argos/modules/forja/services/forja-batch.store';
import { useSyncExternalStore } from 'react';

export function useForjaRunning(): boolean {
  return useSyncExternalStore(forjaBatchStore.subscribe, () =>
    forjaBatchStore.getSnapshot().devices.some((device) => device.status === 'RUNNING'),
  );
}
